type FooterMenuLabelProps = {
  text: string;
};

export const FooterMenuLabel = ({ text }: FooterMenuLabelProps) => {
  return <h4 className="mb-1.5 block font-bold">{text}</h4>;
};
